export const ACTIONS = {
  VISIT_VILLAGE: 'visitVillage',
  ENTER_DUNGEON: 'enterDungeon',
  PREPARE: 'prepare',
  REST: 'rest',
};

export const PHASES = {
  AWAITING_ACTION: 'awaitingAction', // start of turn: choose village/dungeon/prepare/rest
  VILLAGE: 'village',
  DUNGEON: 'dungeon',
  GAME_OVER: 'gameOver',
};

export const BOARD_SIDES = {
  DUNGEON: 'dungeon', // 3 ranks, -2 Attack per point of residual Darkness
  WILDERNESS: 'wilderness', // 4 ranks, -1 Attack per point of residual Darkness
};

export const HALL_RANK_COUNT = {
  [BOARD_SIDES.DUNGEON]: 3,
  [BOARD_SIDES.WILDERNESS]: 4,
};

export const DARKNESS_PENALTY_PER_POINT = {
  [BOARD_SIDES.DUNGEON]: 2,
  [BOARD_SIDES.WILDERNESS]: 1,
};

export const HAND_SIZE = 6;

// Starting deck composition, per player: 6 Regular + 2 Longspear + 2 Torch + 2
// Thunderstone Shard (rulebooks/TS7_Rules_Web.pdf, "Setup"). Card ids match
// scripts/source-data/basics.js -> src/engine/cards/cardDefinitions.generated.js.
export const STARTING_DECK_DEFINITION_IDS = {
  'basic-regular': 6,
  'basic-longspear': 2,
  'basic-torch': 2,
  'basic-thunderstone-shard': 2,
};

export const VILLAGE_BASIC_STACK_IDS = ['basic-regular', 'basic-longspear', 'basic-torch'];

export const HERO_STACKS_PER_GAME = 4; // rulebook: reveal top 4 hero randomizers at setup

// Matt's house rule: "I always remove the regular, longspear, and torch
// stacks and replace them so that I have 5 random hero stacks and 13
// random village stacks. I don't bother sorting them by type it's just
// fully random." See village/villageSetup.js's buildRandomizedVillage.
export const RANDOMIZED_HERO_STACKS_PER_GAME = 5;
export const RANDOMIZED_VILLAGE_STACKS_PER_GAME = 13;

// Matt reported this directly: "I think that when torches or long spears
// are randomly selected to be items in the village, they ought to only
// have 8 copies of each not the full 24 [really 25] copies." Longspear/
// Torch's own copyCounts.total (25) is sized for their ALWAYS-present
// basic-stack role (the full box, capped per-player at 3*playerCount
// elsewhere) - when the randomized-village house rule instead draws one of
// them into a normal village-stack SLOT, it should get the same size any
// other village card in that slot would (matches every other village
// card's own copyCounts.total, which is 8 for all but a couple of
// documented exceptions - see villageSetup.js's own comment).
export const RANDOMIZED_BASIC_VILLAGE_STACK_SIZE = 8;

// Matt: Numenera has no card art anywhere in the Images/ asset dump (every
// legible sheet in both source folders was opened and cataloged - see
// docs/card-image-index.md), and image-scanning it ourselves is a project
// for another day. "We'll need to take the cards out of the card pool
// (don't lose our work just hide them for now)." Rather than removing
// 'Numenera' from scripts/buildCardData.mjs's ALLOWED_SETS (which would
// regenerate cardDefinitions.generated.js without these cards entirely,
// breaking every test that injects a Numenera-only instance id, and every
// exact-count assertion in cardDataPipeline.test.js/
// effectRegistryCoverage.test.js), this is checked at the 4 places a new
// game randomly SELECTS what's actually in play (village/villageSetup.js's
// hero groups and village-card categories, dungeon/dungeonDeckSetup.js's
// monster groups, state/createGameState.js's bearer pool) - every
// Numenera card definition, effect handler, and test stays fully intact,
// it's just never eligible to be picked into a live game. Revisit once
// real art exists (see the "hand-scanning" plan in this session).
export const HIDDEN_SETS = new Set(['Numenera']);

// Rulebook village row, one randomized stack per empty slot on the physical
// board (Guilds and Taverns/Armory/Marketplace/Wizard's College/Town Square),
// on top of the 3 fixed basic stacks (Regular/Longspear/Torch):
export const WEAPON_STACKS_PER_GAME = 3;
export const ITEM_STACKS_PER_GAME = 2;
export const SPELL_STACKS_PER_GAME = 3;
export const VILLAGER_STACKS_PER_GAME = 3;

export const ABILITY_TIMINGS = [
  'village', 'dungeon', 'battle', 'aftermath', 'trophy', 'trophyDungeon', 'global', 'react', 'spoils', 'breach', 'raid',
];
